
import axios from 'axios'
import { API_URL } from '../variables';
const UPLOADIMAGES_URL = '/upload';
const PROCESS_IMAGE_URL = '/processImage';

const files = {
    state: {
    },
    getters: {},
    mutations: {},
    actions: {
        ['UPLOADIMAGES']: ({ commit }, payload) => {
            return axios({
                url: API_URL + UPLOADIMAGES_URL,
                method: "POST",
                data: payload,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
        },
        ['PROCESS_IMAGE']: ({ commit }, payload) => {
            return axios({
                url: API_URL + PROCESS_IMAGE_URL,
                method: "POST",
                data: payload.data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
        },
    },
    modules: {},
}
export default files;